import React from "react";

const LoadingContext = React.createContext();
export default LoadingContext;
